'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const QoyodCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Qoyod"
        title={
          t.customerStories[
            'How Qoyod automates 77% of support for 25,000+ businesses'
          ]
        }
        subtitle={
          t.customerStories[
            'Open fully replaced HubSpot and handles 77% of support across email, chat, WhatsApp, and voice. Businesses get instant help with invoicing, VAT compliance, and financial reporting.'
          ]
        }
        stats={[
          {
            value: isRTL ? '٨٥٪' : '85%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? '+٢٥ ألف' : '25K+',
            label: t.customerStories['Businesses'],
          },
          { value: isRTL ? '٢' : '2', label: t.customerStories['channels'] },
        ]}
        // The film is spoken in Arabic, so it only earns its place on /ar.
        // The English hero falls back to text + stats, as on the story
        // pages that never had footage.
        videoSrc={isRTL ? '/home/stories/qoyod-v2.mp4' : undefined}
        videoStartAt={4.0}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'Qoyod',
          customerName: 'Qoyod',
          company: t.customerStories['qoyod_company_description'],
          industry: t.customerStories['SaaS / Accounting Software'],
          websiteUrl: 'https://www.qoyod.com',
          keyResults: [
            t.customerStories['• 85% automation rate'],
            t.customerStories['• 25,000+ businesses served'],
            t.customerStories['• Fully replaced HubSpot'],
            t.customerStories['• Email and chat covered'],
          ],
        }}
      >
        <p>{t.customerStories['qoyod_intro']}</p>

        <h2>{t.customerStories['qoyod_scale_title']}</h2>
        <p>{t.customerStories['qoyod_scale_p1']}</p>
        <p>{t.customerStories['qoyod_scale_p2']}</p>
        <p>{t.customerStories['qoyod_scale_p3']}</p>

        <h2>{t.customerStories['qoyod_solution_title']}</h2>
        <p>{t.customerStories['qoyod_solution_p1']}</p>
        <p>{t.customerStories['qoyod_solution_p2']}</p>
        <p>{t.customerStories['qoyod_solution_p3']}</p>

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['qoyod_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '٨٥٪' : '85%',
            },
            {
              metric: t.customerStories['Businesses served'],
              impact: isRTL ? '+٢٥ ألف' : '25,000+',
            },
            {
              metric: t.customerStories['Channels covered'],
              impact: t.customerStories['Email and chat'],
            },
            {
              metric: t.customerStories['Previous solution'],
              impact: t.customerStories['Fully replaced HubSpot'],
            },
          ]}
        />

        <p>{t.customerStories['qoyod_results_p1']}</p>

        <h2>{t.customerStories['qoyod_impact_title']}</h2>
        <p>{t.customerStories['qoyod_impact_p1']}</p>
        <p>{t.customerStories['qoyod_impact_p2']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default QoyodCaseStudy;
